import React, { useEffect } from 'react';
import FormModal from '../../Modals/FormModal';
import { useTestProgressAdmin } from '../../../hooks/dte/useTestProgressAdmin';
import InputField from '../../Forms/Input/InputField';
import ToggleSwitch from '../../Forms/Input/ToggleSwitch'; // ✅ usamos el switch que ya tienes
import SectionInfoHeader from '../../common/SectionInfoHeader';
import { Settings, CheckCircle } from 'lucide-react';

interface Props {
  isOpen: boolean;
  close: () => void;
}

const EditTestProgressModal: React.FC<Props> = ({ isOpen, close }) => {
  const {
    form,
    formErrors,
    isSubmit,
    updateField,
    updateProgress,
    cleanFormErrors,
  } = useTestProgressAdmin();

  useEffect(() => {
    if (!isOpen) cleanFormErrors();
  }, [isOpen]);

  const handleSubmit = () => updateProgress();

  return (
    <FormModal
      isOpen={isOpen}
      onClose={close}
      title="Actualizar Progreso de Prueba DTE"
      maxWidth="max-w-xl"
    >
      <SectionInfoHeader
        icon={<Settings className="text-white" />}
        title="Editar Progreso"
        description="Actualiza manualmente el avance registrado para este requisito de prueba."
      />

      <div className="mt-6 flex flex-col gap-6 px-1 pb-2">
        {/* ✅ Solo lectura */}
        <InputField
          label="Documento"
          name="documentName"
          type="text"
          value={form.documentName}
          disabled
        />

        <InputField
          label="Código Documento"
          name="documentCode"
          type="text"
          value={form.documentCode}
          disabled
        />

        <InputField
          label="Cantidad Requerida"
          name="requiredCount"
          type="number"
          value={form.requiredCount}
          disabled
        />

        {/* ✅ Editable: completedCount */}
        <InputField
          label="Cantidad Completada"
          name="completedCount"
          type="number"
          value={form.completedCount ?? ''}
          onChange={(e) =>
            updateField('completedCount', Number(e.target.value))
          }
          error={formErrors.completedCount}
          min={0}
          max={form.requiredCount}
          required
        />

        {/* ✅ Editable: completed */}
        <div className="flex items-center justify-between rounded border px-4 py-3 dark:border-strokedark">
          <span className="flex items-center gap-2 font-medium text-black dark:text-white">
            <CheckCircle className="h-5 w-5 text-primary" />
            Marcar como completado
          </span>
          <ToggleSwitch
            label="Requisito Completado"
            name="completed"
            checked={Boolean(form.completed)}
            onChange={() => updateField('completed', !form.completed)}
            activeColor="success"
            inactiveColor="gray"
          />
        </div>

        {/* ✅ Botón */}
        <button
          onClick={handleSubmit}
          disabled={isSubmit}
          className={`w-full rounded bg-primary px-4 py-2 font-medium text-white transition hover:bg-opacity-90 
            ${isSubmit ? 'cursor-not-allowed opacity-50' : ''}`}
        >
          Guardar Cambios
        </button>
      </div>
    </FormModal>
  );
};

export default EditTestProgressModal;
